import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { useDeleteAPIKeyMutation } from '@generated/graphql';
import { Stack } from '@mui/material';

export const DeleteApiKeyModal = ({ name, onClose }: { name: string; onClose: () => void }) => {
  const [deleteAPIKey] = useDeleteAPIKeyMutation();
  const onDelete = async () => {
    await deleteAPIKey({ variables: { name } });
    onClose();
  };

  return (
    <Stack pt={4} gap={10} justifyContent="center">
      <Typography variant="body2" align="center">
        Are you sure you want to delete the API key: {name}?
      </Typography>
      <Stack gap={4}>
        <Button fullWidth onClick={onDelete}>
          Delete
        </Button>
        <Button fullWidth onClick={onClose} variant="secondary">
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
